
import React                                       from 'react';
import { Observe }                                 from 'rewire-core';
import {
  WithStyle,
}                                                  from 'rewire-ui';
import { Theme }                                   from '@material-ui/core/styles';
import Typography                                  from '@material-ui/core/Typography';
import infoPanelShiftSchedulingHeaderViewModel     from './InfoPanelShiftSchedulingHeaderViewModel';
import ScheduleRuleDialog                          from './ScheduleRuleDialog';
import { withStyles }                              from '../utility/styles';

const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 0px 0px 0px',
  },
  headerInputsContainer: {
    marginTop: '15px',
    marginBottom: '15px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  input: {
    width: '48%',
    maxWidth: '48%',
  },
});

interface IInfoPanelShiftSchedulingHeaderViewProps {
}

type InfoPanelShiftSchedulingHeaderViewProps = WithStyle<ReturnType<typeof styles>, IInfoPanelShiftSchedulingHeaderViewProps>;

class InfoPanelShiftSchedulingHeaderView extends React.PureComponent<InfoPanelShiftSchedulingHeaderViewProps> {
  constructor(props: InfoPanelShiftSchedulingHeaderViewProps) {
    super(props);
  }

  render() {
    const {classes} = this.props;

    return <Observe render={() => (
      <div className={classes.root}>
        <Typography variant='h6'>Candidate Employees List</Typography>
        <div className={classes.headerInputsContainer}>
          <infoPanelShiftSchedulingHeaderViewModel.form.field.employeeSearch.Editor className={classes.input}/>
          <infoPanelShiftSchedulingHeaderViewModel.form.field.schedulingRule.Editor className={classes.input} />
        </div>
        <ScheduleRuleDialog />
      </div>
    )} />;
  }
}

export default withStyles<IInfoPanelShiftSchedulingHeaderViewProps>(styles, InfoPanelShiftSchedulingHeaderView);
